import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ArchiveIcon from '@mui/icons-material/Archive';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowLeftSharpIcon from '@mui/icons-material/ArrowLeftSharp';
import ArrowRightSharpIcon from '@mui/icons-material/ArrowRightSharp';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import BackupIcon from '@mui/icons-material/Backup';
import BadgeIcon from '@mui/icons-material/Badge';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ConstructionIcon from '@mui/icons-material/Construction';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DevicesFoldIcon from '@mui/icons-material/DevicesFold';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditIcon from '@mui/icons-material/Edit';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import EditNoteIcon from '@mui/icons-material/EditNote';
import EditRoadIcon from '@mui/icons-material/EditRoad';
import EmailIcon from '@mui/icons-material/Email';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import EuroIcon from '@mui/icons-material/Euro';
import EventIcon from '@mui/icons-material/Event';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import FreeCancellationIcon from '@mui/icons-material/FreeCancellation';
import GroupIcon from '@mui/icons-material/Group';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HelpIcon from '@mui/icons-material/Help';
import HistoryIcon from '@mui/icons-material/History';
import ImageIcon from '@mui/icons-material/Image';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import LandscapeIcon from '@mui/icons-material/Landscape';
import LightModeIcon from '@mui/icons-material/LightMode';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockResetIcon from '@mui/icons-material/LockReset';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NotesIcon from '@mui/icons-material/Notes';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import OutputIcon from '@mui/icons-material/Output';
import PaletteIcon from '@mui/icons-material/Palette';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PlaceIcon from '@mui/icons-material/Place';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import PostAddIcon from '@mui/icons-material/PostAdd';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import PreviewIcon from '@mui/icons-material/Preview';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import PrintIcon from '@mui/icons-material/Print';
import PublicIcon from '@mui/icons-material/Public';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import RemoveIcon from '@mui/icons-material/Remove';
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import ResetTvIcon from '@mui/icons-material/ResetTv';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ScaleIcon from '@mui/icons-material/Scale';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import SendIcon from '@mui/icons-material/Send';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SmartButtonIcon from '@mui/icons-material/SmartButton';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import StarSharpIcon from '@mui/icons-material/StarSharp';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TableChartIcon from '@mui/icons-material/TableChart';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import TodayIcon from '@mui/icons-material/Today';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import WarningIcon from '@mui/icons-material/Warning';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { CircularProgress, SvgIconProps } from '@mui/material';
import React from 'react';

const iconMap = {
    addCircle: AddCircleIcon,
    deleteForever: DeleteForeverIcon,
    calendarMonth: CalendarMonthIcon,
    settingsBackupRestore: SettingsBackupRestoreIcon,
    arrowForward: ArrowForwardIcon,
    arrowBack: ArrowBackIcon,
    sendToMobile: SendToMobileIcon,
    warning: WarningIcon,
    eventRepeat: EventRepeatIcon,
    accessTime: AccessTimeIcon,
    edit: EditIcon,
    delete: DeleteIcon,
    menu: MenuIcon,
    visibility: VisibilityIcon,
    visibilityOff: VisibilityOffIcon,
    fileDownload: FileDownloadIcon,
    logout: LogoutIcon,
    lock: LockIcon,
    close: CloseIcon,
    output: OutputIcon,
    peopleAlt: PeopleAltIcon,
    precisionManufacturing: PrecisionManufacturingIcon,
    phonelinkErase: PhonelinkEraseIcon,
    resetTv: ResetTvIcon,
    addToHomeScreen: AddToHomeScreenIcon,
    verticalAlignTop: VerticalAlignTopIcon,
    verticalAlignBottom: VerticalAlignBottomIcon,
    palette: PaletteIcon,
    starSharp: StarSharpIcon,
    arrowLeftSharp: ArrowLeftSharpIcon,
    arrowRightSharp: ArrowRightSharpIcon,
    locationOnSharp: LocationOnSharpIcon,
    infoSharp: InfoSharpIcon,
    keyboardArrowDownSharp: KeyboardArrowDownSharpIcon,
    keyboardArrowRightSharp: KeyboardArrowRightSharpIcon,
    help: HelpIcon,
    login: LoginIcon,
    badge: BadgeIcon,
    pictureAsPdf: PictureAsPdfIcon,
    email: EmailIcon,
    searchOff: SearchOffIcon,
    doNotDisturb: DoNotDisturbIcon,
    image: ImageIcon,
    autoMode: AutoModeIcon,
    lockReset: LockResetIcon,
    playListAddCircle: PlaylistAddCircleIcon,
    today: TodayIcon,
    calendarToday: CalendarTodayIcon,
    chevronRight: ChevronRightIcon,
    viewSideBar: ViewSidebarIcon,
    localGasStation: LocalGasStationIcon,
    editCalendar: EditCalendarIcon,
    summarize: SummarizeIcon,
    airportShuttle: AirportShuttleIcon,
    construction: ConstructionIcon,
    adminPanelSettings: AdminPanelSettingsIcon,
    business: BusinessIcon,
    analytics: AnalyticsIcon,
    devicesFold: DevicesFoldIcon,
    sendTimeExtension: SendTimeExtensionIcon,
    plagiarism: PlagiarismIcon,
    equalizer: EqualizerIcon,
    preview: PreviewIcon,
    euro: EuroIcon,
    freeCancellation: FreeCancellationIcon,
    done: DoneIcon,
    doneAll: DoneAllIcon,
    publishedWithChanges: PublishedWithChangesIcon,
    send: SendIcon,
    monetizationOn: MonetizationOnIcon,
    restartAlt: RestartAltIcon,
    wifiOff: WifiOffIcon,
    contentCopy: ContentCopyIcon,
    settings: SettingsIcon,
    addRoad: AddRoadIcon,
    editRoad: EditRoadIcon,
    removeRoad: RemoveRoadIcon,
    tableChart: TableChartIcon,
    event: EventIcon,
    smartButton: SmartButtonIcon,
    editNote: EditNoteIcon,
    spaceDashboard: SpaceDashboardIcon,
    public: PublicIcon,
    personOff: PersonOffIcon,
    person: PersonIcon,
    scale: ScaleIcon,
    lightMode: LightModeIcon,
    darkMode: DarkModeIcon,
    arrowCircleLeft: ArrowCircleLeftIcon,
    arrowCircleRight: ArrowCircleRightIcon,
    search: SearchIcon,
    arrowUpward: ArrowUpwardIcon,
    arrowDownward: ArrowDownwardIcon,
    importExport: ImportExportIcon,
    listAlt: ListAltIcon,
    moreVert: MoreVertIcon,
    add: AddIcon,
    history: HistoryIcon,
    fileOpen: FileOpenIcon,
    dragIndicator: DragIndicatorIcon,
    cancel: CancelIcon,
    backup: BackupIcon,
    insertDriveFile: InsertDriveFileIcon,
    postAdd: PostAddIcon,
    group: GroupIcon,
    remove: RemoveIcon,
    taskAlt: TaskAltIcon,
    transferWithinAStation: TransferWithinAStationIcon,
    lockOpen: LockOpenIcon,
    checkCircleOutline: CheckCircleOutlineIcon,
    personOutline: PersonOutlineIcon,
    navigateNext: NavigateNextIcon,
    print: PrintIcon,
    archive: ArchiveIcon,
    unarchive: UnarchiveIcon,
    insertPhoto: InsertPhotoIcon,
    cloudUpload: CloudUploadIcon,
    cloudDownload: CloudDownloadIcon,
    shoppingCart: ShoppingCartIcon,
    handshake: HandshakeIcon,
    inventory2: Inventory2Icon,
    localShipping: LocalShippingIcon,
    landscape: LandscapeIcon,
    priceChange: PriceChangeIcon,
    factCheck: FactCheckIcon,
    place: PlaceIcon,
    openInNew: OpenInNewIcon,
    notes: NotesIcon,
};

export interface IconProps extends SvgIconProps {
    name: keyof typeof iconMap;
    loading?: boolean;
}

const Icon: React.FC<IconProps> = ({ name, loading = false, ...props }) => {
    const IconComponent = iconMap[name];

    if (!IconComponent) {
        console.warn(`Unknown icon name: ${name}`);
        return null;
    }

    return <>{loading ? <CircularProgress size={20} color="inherit" /> : <IconComponent fontSize="medium" {...props} />}</>;
};

export default Icon;
